import React, { Component, useEffect, useRef, useState } from 'react';
import { Input, Button, Row, Col } from 'antd';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import LinkCount from '../InputList/LinkCount';
import NameFilter from './NameFilter';
const { TextArea } = Input;

export default function InputShootList({ UpdateItems, links = null, setLinksValidation, linksValidation, maxHeight = '35vh' }) {
    const [items, setItems] = useState(['']);
    const [valItems, setValItems] = useState([false]);
    const nextId = useRef(1);
    const [ids, setIds] = useState([0]);

    useEffect(() => {
        !!links && setItems(links);
        !!links && setValItems([...links.map(() => false)]);
        !!links && setIds(links.map(() => nextId.current++));
        !links && setItems(['']);
        !links && setValItems([false]);
    }, []);

    useEffect(() => {
        if (valItems.length !== items.length || !valItems.every(item => item === true)) {
            setLinksValidation(true);
        } else {
            setLinksValidation(false);
        }
    }, [valItems, items.length]);

    const HandleAddItem = () => {
        const prev = [...items];
        prev.push('');
        setItems(prev);
        UpdateItems(prev);

        const vPrev = [...valItems];
        vPrev.push(false);
        setValItems(vPrev);

        setIds([...ids, nextId.current++]);
    };

    const HandleInputChange = (e, index) => {
        const prev = [...items];
        prev[index] = e;
        setItems(prev);
        UpdateItems(prev);
    };

    const HandleInputRemove = index => {
        let prev = [...items];
        const removedItems = prev.splice(index, 1);
        setItems(prev);
        UpdateItems(prev);

        const vPrev = [...valItems];
        vPrev.splice(index, 1);
        setValItems(vPrev);

        setIds(ids.filter((_, i) => i !== index));
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    maxHeight: maxHeight,
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    overflow: 'auto',
                    border: '1px dashed black',
                }}
            >
                {items?.map((item, index) => {
                    return (
                        <div
                            key={ids[index] ?? index}
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                margin: '5px',
                                padding: '10px',
                                backgroundColor: '#eee',
                                borderRadius: '10px',
                            }}
                        >
                            <Row style={{ width: '100%', display: 'flex', alignItems: 'baseline' }}>
                                <Col flex="25px">
                                    <p
                                        style={{
                                            marginRight: '10px',
                                            backgroundColor: 'black',
                                            borderRadius: '50%',
                                            color: 'white',
                                            width: '80%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {index + 1}
                                    </p>
                                </Col>
                                <Col flex="auto">
                                    <NameFilter
                                        searchName={item}
                                        itemUpdater={e => HandleInputChange(e, index)}
                                        index={index}
                                        setValItems={setValItems}
                                        items={items}
                                    />
                                </Col>
                                <Col flex="40px">
                                    <Button onClick={() => HandleInputRemove(index)} style={{ margin: '0 5px' }} disabled={items?.length === 1}>
                                        <DeleteOutlined />
                                    </Button>
                                </Col>
                                <Col flex="40px">
                                    <Button type="primary" onClick={() => HandleAddItem()} style={{ margin: '0 5px' }}>
                                        <PlusCircleOutlined />
                                    </Button>
                                </Col>
                                <Col flex="40px">
                                    <LinkCount link={item} />
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
